// extracted by mini-css-extract-plugin
export default {"tooltip":"qPIEUq","bubble":"MNbxxx","tooltipTriangle":"J903o9"};